import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import Button from "react-bootstrap/Button";
import Connect from "react-redux/es/connect/connect";
import {dispatchOnCreateArticlesSetArticleToEditChanged} from "./article/functions";
import {debug} from "../../../utility/functions";

class CreateArticle extends PureComponent {

    // This functions is called when new multimedia or new gallery is button pressed
    // Redirecting the client/user to the appropriate page
    onCreateNewButtonClicked = (redirect) => {
        if(!this.props.hasUnsavedChanges) {
            this.props.dispatchOnCreateArticlesSetArticleToEditChanged(null)
        }
        this.props.history.push(redirect);
    };

    render() {
        const {t} = this.props;
        return (
            <div>
                <div className="container-createnews">
                    <div className="container-header">
                        <div className="container-header-tittle"><h2>{t('News')}</h2></div>
                        <div className='container-header-arrow'>{">"}</div>
                        <div className="container-header-subtittle">{t('New News')}</div>
                    </div>
                    <div className="container-createnews-body">
                        <div className="container-createnews-body-actions">
                            <div className="container-createnews-body-action-multimedia-new-div-container">
                                <div className="container-createnews-body-action-multimedia-new-div">
                                    <Button className="container-createnews-body-action-multimedia-new-button" style={{margin: 0}}
                                            onClick={() => this.onCreateNewButtonClicked('/create-news/multimedia')}>
                                        <div>
                                            <div className="multimedia-new-button-title">
                                                <div>
                                                    <div
                                                        className="multimedia-new-button-title-strong">{t('NEW')}</div>
                                                    <div
                                                        className="multimedia-new-button-title-normal">{t('Multimedia New')}</div>
                                                </div>
                                            </div>
                                            <div className="multimedia-new-button-icon">
                                                <img alt="news multimedia"
                                                     src="../../../assets/news_multimedia.png"/>
                                            </div>
                                        </div>
                                    </Button>
                                    <div className="multimedia-new-button-info">
                                        A <strong>NOTÍCIA MULTIMÉDIA</strong> permite que adiciones ao teu texto principal, fotos e/ou vídeos, que ilustrem a notícia que estás a criar.
                                    </div>
                                </div>
                            </div>
                            <div className="container-createnews-body-action-gallery-new-div-container">
                                <div className="container-createnews-body-action-gallery-new-div">
                                    <Button className="container-createnews-body-action-gallery-new-button" style={{margin: 0}}
                                            onClick={() => this.onCreateNewButtonClicked('/create-news/gallery')}>
                                        <div>
                                            <div className="gallery-new-button-title">
                                                <div>
                                                    <div
                                                        className="gallery-new-button-title-strong">{t('NEW')}</div>
                                                    <div
                                                        className="gallery-new-button-title-normal">{t('Gallery New')}</div>
                                                </div>
                                            </div>
                                            <div className="gallery-new-button-icon">
                                                <img alt="news multimedia"
                                                     src="../../../assets/news_gallery.png"/>
                                            </div>
                                        </div>
                                    </Button>
                                    <div className="gallery-new-button-info">
                                        A <strong>NOTÍCIA MULTIMÉDIA</strong> permite que adiciones ao teu texto principal, fotos e/ou vídeos, que ilustrem a notícia que estás a criar.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    hasUnsavedChanges: store.createNewArticlesReducer.hasUnsavedChanges,
    articleToEdit: store.createNewArticlesReducer.articleToEdit,
});

const mapFunctionsToProps = {
    dispatchOnCreateArticlesSetArticleToEditChanged
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(CreateArticle));
